.f7{width:max-content;}